// extracted by mini-css-extract-plugin
export default {"categories":"categories_categories__261lL","child_cat_list":"categories_child_cat_list__ehh-Y","child_cat_title":"categories_child_cat_title__V9CFi"};